if (!customElements.get('pdp-promo-carousel')) {
  class PdpPromoCarousel extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('.pdp-promo-card')];
      if (this.cards.length < 2 || this.dataset.static === 'true') return;

      this.current = this.cards.findIndex((card) => card.classList.contains('is-active'));
      if (this.current < 0) this.current = 0;

      const intervalSeconds = parseInt(this.dataset.interval, 10);
      this.intervalMs = (Number.isFinite(intervalSeconds) ? intervalSeconds : 5) * 1000;
      this.timer = window.setInterval(() => this.showNext(), this.intervalMs);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    showNext() {
      this.cards[this.current].classList.remove('is-active');
      this.current = (this.current + 1) % this.cards.length;
      this.cards[this.current].classList.add('is-active');
    }
  }

  customElements.define('pdp-promo-carousel', PdpPromoCarousel);
}
